// JsFromRoutes CacheKey a64e5230b77974d23737e1d42ee64dc0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/patterns'),
}
